import $ from "jquery";

const ampmAccordion = () => {
  const init = () => {
    toggleAccordion();
  };

  const toggleAccordion = () => {
    const el = {
      button: ".js-Ampm__Container_Tab",
      contents: ".js-Ampm__Container_Tab .mi-Ampm__Container_Tab__Description",
      content: ".mi-Ampm__Container_Tab__Description",
    };

    $(el.contents).hide();
    $(document).on("click", el.button, function () {
      $(el.contents).hide(300);
      //   console.log($(this).find(el.content));
      $(this).find(el.content).show(300);
    });
  };

  init();
};

try {
  ampmAccordion();
} catch (error) {
  console.error(error);
}
